import { ContentWorkflow } from '@amzn/awscat-pattern-library-service-model';
import React from 'react';
import { IMplServiceClient } from '../../api/IMplServiceClient';
import { MplServiceClientFactory } from '../../api/MplServiceClientFactory';
import constants from '../../common/constants';
import { WorkflowTableIdentity } from '../../common/CookieRegistry';
import { WorkflowActions } from '../../model/Enum';
import Breadcrumbs from '../common/Breadcrumbs';
import PageCanvas from '../common/PageCanvas';
import { UpdatedDateCol } from '../content-requests/ContentRequestColumnDefinition';
import { ContentIdCol } from '../publication/PublicationSearchResultColumnDefinitions';
import {
  ApprovalsCol,
  ContentAudienceCol,
  ContentTypeCol,
  DisapprovalsCol,
  IsTestDataCol,
  OwnerCol,
  PublisherContentNameCol,
  RankCol,
  IsBarRaiserDomainColumn,
} from '../workflow-viewer/ContentWorkflowColumnDefinitions';
import ContentWorkflowTable from '../workflow-viewer/ContentWorkflowTable';
import { Box } from '@amzn/awsui-components-core';

interface State {
  isLoading: boolean;
  contentWorkflows: ContentWorkflow[];
}

class ContentsToPublish extends React.Component<{}, State> {
  private mplServiceClient: IMplServiceClient;
  private columnDefinitions = [
    ContentIdCol,
    ContentAudienceCol,
    PublisherContentNameCol,
    ContentTypeCol,
    OwnerCol,
    UpdatedDateCol,
    ApprovalsCol,
    DisapprovalsCol,
    RankCol,
    IsTestDataCol,
    IsBarRaiserDomainColumn,
  ];

  // @ts-expect-error TS7006 - strict migration
  constructor(props) {
    super(props);
    this.mplServiceClient = MplServiceClientFactory.create();
    this.state = {
      contentWorkflows: [],
      isLoading: true,
    };
  }

  public async componentDidMount() {
    this.loadData();
  }

  public render() {
    const { isLoading, contentWorkflows } = this.state;
    const breadcrumbItems = [
      { text: constants.APP_NAME_BREAD_CRUMB, href: '/' },
      { text: constants.PUBLISHER_CONTENTS_HEADER, href: '' },
    ];
    return (
      <div>
        <Breadcrumbs items={breadcrumbItems} />
        <Box padding={{ top: 'm' }}>
          <ContentWorkflowTable
            tableId={WorkflowTableIdentity.ContentsToPublish}
            loading={isLoading}
            header={constants.PUBLISHER_CONTENTS_HEADER}
            onRefreshClick={this.loadData}
            workflows={contentWorkflows}
            columnDefinitions={this.columnDefinitions}
            allowedControlActions={[WorkflowActions.EDIT_WORKFLOW]}
            allowedFilterTypes={['contentType']}
          />
        </Box>
      </div>
    );
  }

  private loadData = async () => {
    this.setState({
      isLoading: true,
    });
    const response = await this.mplServiceClient.getContentsToPublish();
    this.setState({
      contentWorkflows: response.workflows,
      isLoading: false,
    });
  };
}

export default ContentsToPublish;
